export const CONTRABAND_EVIDENCE = [
  { value: 'DRUGS', label: 'Drugs' },
  { value: 'WEAPONS', label: 'Weapons' },
  { value: 'STOLEN_PROPERTY', label: 'Stolen Property' },
  { value: 'CURRENCY', label: 'Currency' },
  { value: 'ALCOHOL', label: 'Alcohol' },
  { value: 'OTHER', label: 'Other' },
  { value: 'NOT_APPLICABLE', label: 'N/A' },
] as const;
